export default "__VITE_ASSET__Bj8jnqhh__"